var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4747 6.17065L10.3573 9.28808L13.4488 12.3795C13.7085 12.6133 13.7085 13.003 13.4488 13.2368C13.2149 13.4966 12.8253 13.4966 12.5915 13.2368L9.47402 10.1454L6.38257 13.2368C6.14876 13.4966 5.75908 13.4966 5.52527 13.2368C5.26548 13.003 5.26548 12.6133 5.52527 12.3536L8.61673 9.26211L5.52527 6.17065C5.26548 5.93684 5.26548 5.54716 5.52527 5.28738C5.75908 5.05357 6.14876 5.05357 6.40854 5.28738L9.5 8.40481L12.5915 5.31335C12.8253 5.05357 13.2149 5.05357 13.4747 5.31335C13.7085 5.54716 13.7085 5.93684 13.4747 6.17065Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3f1b635f62c3116cfac00922a2eefa5e.svg";
export { ForwardRef as ReactComponent };